import { Link } from '@/shared/components/Link';
import { externalConnections } from '@/constants/Constants';
import { Box, useTheme } from '@mui/material';

export function SignUpLink() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Link
        data-variant="navItem"
        underline="none"
        href={externalConnections.signin}
        sx={{
          '&::after': {
            bottom: '-20% !important',
            [`@media screen and (max-width: ${theme.breakpoints.values.sm}px)`]: {
              bottom: '-16% !important',
            },
          },
        }}
      >
        Sign In
      </Link>
    </Box>
  );
}
